import { makeAutoObservable } from "mobx";
import ViewModel from "../../../ViewModel";
import src from '../../../../assets/logo.png';
import FsService from "../../../../services/FsService";
import {wsService, MessageType} from "../../../../services/WebSocketService";
import { Console } from "console";





export default class FsVM implements ViewModel {
    onClose: () => void;
    formFile: File;
    file: string = src;

    constructor(onClose: () => void) {
        this.onClose = onClose;
        makeAutoObservable(this);
    }

    setFormFile = (value: File) => {
        this.formFile = value;
    }

    setFile = (value: string) => {
        this.file = value;
    }

    sendFile = () => {
        FsService.upload(this.formFile);
        this.onClose();
    }
    sendFileBeta = () => {
        FsService.uploadBeta(this.formFile);
        this.onClose();
    }

    testWs = () => {
        console.log(wsService.isConnected());
        wsService.sendMessage(MessageType.Ping, 1, new Uint8Array());
    }
}